/* eslint-disable import/prefer-default-export */
export enum GenderType {
    MALE = 'MALE',
    FEMALE = 'FEMALE'
}
